import {
  ConvertMinutesToTimeRemain,
  Gender,
  getCellStyle,
  getFormatAge,
  GetHeaderStyle,
  GetImageStduyStatus,
  UrgentType,
} from "../../core/Helper";
import { GetThaiDateTimeCheckToday } from "../../core/ThaiDate";

const formatStatus = (cell, row) => {
  return <GetImageStduyStatus id={row.action_id} />;
};

const calRemainTime = (cell, row) => {
  // console.log("check row", row);
  if (row?.diag_finish === "y") return;
  else return ConvertMinutesToTimeRemain(row.remaining_time);
};
const customTextFilter = {
  placeholder: "...",
};
// export const GetRadiWorkListColumn = (isNormal) =>
//   new Promise((resolve, reject) => {
//     resolve(getCol());
//   });

export const getRadColumns = () => {
  const fontName = "tahoma";
  const fontSize = "14px";
  const dateSize = "14px";
  let cols = [
    {
      dataField: "action_dt",
      text: "วันที่ส่ง",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: () =>
        getCellStyle(
          "center",
          "var(--date-sent)",
          dateSize,
          fontName
          // "1px solid var(--date-border)"
        ),
      // filter: textFilter(customTextFilter),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },

    {
      dataField: "result_expected",
      text: "วันที่รับผล",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle(
        "center",
        "var(--date-appoint)",
        dateSize,
        fontName
        // "1px solid var(--date-border)"
      ),
      // filter: textFilter(customTextFilter),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },
    // {
    //   dataField: "radi_received_time",
    //   text: "รับเคส",
    //   sort: true,
    //   headerStyle: () => GetHeaderStyle("100px"),
    //   style: getCellStyle(
    //     "center",
    //     "var(--date-accepted)",
    //     dateSize,
    //     fontName
    //     // "1px solid var(--date-border)"
    //   ),
    //   // filter: textFilter(customTextFilter),
    //   formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    // },
    {
      dataField: "remaining_time",
      text: "Countdown",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px"),
      style: getCellStyle(
        "center",
        "var(--date-remaining)",
        dateSize,
        fontName
        // "1px solid var(--date-border)"
      ),
      // filter: textFilter(customTextFilter),
      formatter: calRemainTime,
    },
    {
      dataField: "urgenttype_name",
      text: "Priority",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px", "left", "niramit", "18px"),
      style: () =>
        getCellStyle(
          "left",
          null,
          fontSize,
          fontName
          // "1px solid var(--date-border)"
        ),
      formatter: UrgentType,
      // filter: textFilter(customTextFilter),
    },
    {
      dataField: "brchshort",
      text: "รพ.ที่ส่ง",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      // filter: textFilter(customTextFilter),
    },
    {
      dataField: "patients_name",
      text: "ชื่อ-สกุลผู้ป่วย",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
    },
    {
      dataField: "patientid",
      text: "HN",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      // filter: textFilter(customTextFilter),
    },
    {
      dataField: "part",
      text: "Description",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto", "left"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      // filter: textFilter(customTextFilter),
    },

    {
      dataField: "patients_sex",
      text: "เพศ",
      sort: true,
      headerStyle: () => GetHeaderStyle("80px", "center"),
      style: () => getCellStyle("center", null, fontSize, fontName),
      // filter: textFilter(customTextFilter),
      formatter: Gender,
    },
    {
      dataField: "patients_age",
      text: "อายุ",
      sort: true,
      headerStyle: () => GetHeaderStyle("80px", "center"),
      style: () => getCellStyle("center", null, fontSize, fontName),
      // filter: textFilter(customTextFilter),
      formatter: getFormatAge,
    },
    {
      dataField: "modality",
      text: "Modality",
      sort: true,
      headerStyle: () => GetHeaderStyle("80px"),
      style: () => getCellStyle("center", null, fontSize, fontName),
      // filter: textFilter(customTextFilter),
    },

    // {
    //   dataField: "test",
    //   text: "ไฟล์",
    //   style: getCellStyle(
    //     "center",
    //     null,
    //     fontSize,
    //     fontName
    //     // "1px solid var(--date-border)"
    //   ),
    //   headerStyle: () => GetHeaderStyle("80px"),
    //   formatter: (x, row) => DicomStatusHeader(x, row),
    // },
    // {
    //   dataField: "test",

    //   text: CreateTooltip(
    //     "File Upload Status",
    //     <div style={defaultHeaderContainerStyle}>
    //       <FiUploadCloud style={defaultHeaderIconStyle} />
    //     </div>
    //   ),
    //   style: getCellStyle("center"),
    //   headerStyle: GetHeaderStyle("80px", "middle"),
    //   formatter: (x, row) => DicomStatusHeader(x, row),
    // },
    {
      dataField: "action_event",
      text: "Status",
      headerStyle: () => GetHeaderStyle("120px"),
      style: getCellStyle("left", null, fontSize, fontName),
      formatter: formatStatus,
      align: "center",
    },
  ];
  return cols;
};
